//$w('#813Eb645C6Bd4870906D694F30869Fd91')
import wixData from 'wix-data';

$w.onReady(function () {
    /* ===========================================
    ======== Code Added by Alister Esmond ========
    =========================================== */

    let $date = new Date
    let $dateDifferenceMil = Date.now() - 604800000;
    let $dateDiff = new Date($dateDifferenceMil);

    wixData.query("Verses")
        .le("date", $date)
        .and(
            wixData.query("Verses")
            .ge("date", $dateDiff)
        )
        .descending("date")
        .find()
        .then((res) => {
            $w('#verseTitle').text = res.items[0].title;
            $w('#verse').text = res.items[0].verse;
            $w('#verseBtn').link = res.items[0]['link-verses-title'];

            let $getMonth = new Date(res.items[0].date).getMonth();
            let $months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            let $getDate = (new Date(res.items[0].date).getDate()).toString();

            $w('#verseDate').text = $months[$getMonth].concat(" ").concat($getDate);
        })
});